import { render, staticRenderFns } from "./issuingAuthorityListAddEdit.vue?vue&type=template&id=1585885d&scoped=true"
import script from "./issuingAuthorityListAddEdit.vue?vue&type=script&lang=js"
export * from "./issuingAuthorityListAddEdit.vue?vue&type=script&lang=js"
import style0 from "./issuingAuthorityListAddEdit.vue?vue&type=style&index=0&id=1585885d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1585885d",
  null
  
)

export default component.exports